import TalToast from './main'

let instance
const TYPES = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']

const plugin = {
  install (Vue, options) {
    let ToastConstructor = Vue.extend(TalToast)

    // 安装时即挂载
    if (!instance) {
      instance = new ToastConstructor({
        el: document.createElement('div')
      })
      document.body.appendChild(instance.$el)
    }

    function toast (options = {}, duration) {
      if (typeof options === 'string') {
        instance.text = options
      } else if (typeof options === 'object') {
        Object.assign(instance, options)
      }
      if (instance.timer) {
        clearTimeout(instance.timer)
      }
      instance.show = true
      return new Promise((resolve, reject) => {
        instance.timer = setTimeout(() => {
          instance.show = false
          resolve('success')
        }, instance.duration)
      })
    }
    // map shortcut methods
    TYPES.map(v => {
      toast[v] = function (options, duration) {
        options = typeof options === 'string'
          ? {
            type: v,
            text: options,
            duration: duration || 2000
          }
          : {
            type: v,
            duration: duration || 2000,
            ...options
          }
        toast(options)
      }
    })

    Vue.toast = Vue.prototype.$toast = toast
  }
}

export default plugin
